import React from 'react';
import Reveal from './Reveal';

/**
 * The WordPress site's section marker: a skewed olive "tape" sticker with
 * white hand-lettering, sitting on a dashed rule (see "OUR LOCATIONS" /
 * "WHAT'S ON" on wethelocal.co).
 */
export default function TapeLabel({ children, id }) {
  return (
    <Reveal className="tape-row" id={id}>
      <span className="tape-row__rule" aria-hidden="true" />
      <h2 className="display brand tape">{children}</h2>
      <span className="tape-row__rule" aria-hidden="true" />
    </Reveal>
  );
}
